const Globals = require('../../../utils/Globals');
const $ = require('jquery');
const _ = require('underscore');
const Backbone = require('backbone');
const RoleModel = require('../models/RoleModel');
const ActionCollection = require('../../action/models/ActionCollection');
const ReportCollection = require('../../report/models/ReportCollection');
const AlertView = require('../../app/views/AlertView');
const ConfirmView = require('../../app/views/ConfirmView');
const html = require('../templates/detail_view.template');

const DetailView = Backbone.View.extend({
    model: null,
    initialize(options) {
        this.options = options;
    },
    render(id) {
        this.model = new RoleModel({ id });
        $.scrollTo('#hauptrahmen', 300);
        const view = this;
        $(this.el).spinner();
        if (_.isUndefined(id)) {
            view.renderTemplate(html);
        } else {
            view.model.fetch({
                success() {
                    view.renderTemplate(html);
                }
            });
        }
    },
    renderTemplate() {
        const view = this;
        view.options.listView.$('div.roles-content-detail').html(_.template(html)({ model: view.model, $ }));
        view.setElement('#role-detail-view');
        view.renderActions();
        view.renderReports();
        view.renderModules({
            success() { view.$el.fadeIn(); }
        });
    },
    renderActions() {
        const actions = new ActionCollection();
        const roleactions = new ActionCollection(this.model.get('actions'));
        const view = this;
        actions.fetch({
            success() {
                _.renderMultiCheckbox('actions[].id', roleactions, actions, view.$('.actionsCheckbox'), 'code');
                view.$('.actionsCheckbox').parent().uicheckbox('init');
            }
        });
    },
    renderReports() {
        const reports = new ReportCollection();
        reports.url = Globals.baseUrl + 'roles/reports';
        const roleReports = new ReportCollection(this.model.get('reports'));
        const view = this;
        reports.fetch({
            // data: {role_id:view.model.id},
            success() {
                _.renderMultiCheckbox({
                    inputName: 'reports[].id',
                    selectModels: roleReports,
                    models: reports,
                    appendEle: view.$('.reportsCheckbox'),
                    valueName: 'name',
                    category: 'reportCategory',
                    showIdent: true
                });
                view.$('.reportsCheckbox').parent().uicheckbox('init');
            }
        });
    },
    renderModules(options) {
        const modules = Globals.user.get('modules');
        const view = this;
        const InterfaceView = require('../../interface/views/InterfaceListView');
        this.addModule(InterfaceView, true);
        _.each(modules, module => {
            if (module.role) {
                // Leider anderer Dynamischer Import mit den alten Modulen nicht möglich
                if (module.name === 'olap') {
                    import('../../../modules/olap/views/' + module.viewname).then(MView => {
                        view.addModule(MView, false);
                    });
                }
                if (module.name === 'dashboard') {
                    import('../../../modules/dashboard/views/' + module.viewname).then(MView => {
                        view.addModule(MView, false);
                    });
                }
                if (module.name === 'multiedit') {
                    import('../../../modules/multiedit/views/' + module.viewname).then(MView => {
                        view.addModule(MView, false);
                    });
                }
            }
        });
        options.success();
    },
    addModule(Module, left) {
        const view = this;
        let appendName = '.fieldset-right';
        if (left) {
            appendName = '.fieldset-left';
        }
        const appendEl = view.$(appendName);
        Module.getForRole(view, appendEl);
        view.saveModules.push(Module.saveToRole);
    },
    events: {
        'click .rolesave': 'saveRole',
        'click #delete-role': 'deleteRole'
    },
    saveModules: [],

    saveRole() {
        this.model.unset('actions', { silent: true });
        this.model.unset('reports', { silent: true });
        this.model.setForm(this.$('form'));
        const view = this;
        this.model.save(formMessage => {
            if (formMessage.showErrors()) {
                const noId = _.isUndefined(view.model.id);
                if (noId) {
                    view.model.id = formMessage.getGid();
                }
                const alertView = () => {
                    AlertView.show({
                        message: $._('role.alert.save.success'),
                        okFunc() {
                            if (noId) {
                                view.options.listView.render();
                            } else {
                                view.render(view.model.id);
                            }
                        }
                    });
                };
                if (_.isUndefined(view.saveModules) || view.saveModules.length === 0) {
                    alertView();
                } else {
                    const allModules = view.saveModules.length;
                    let startSave = 0;
                    const afterSave = () => {
                        if (startSave >= allModules) {
                            alertView();
                        }
                    };
                    _.each(view.saveModules, saveModul => {
                        startSave += 1;
                        saveModul(view.model, {
                            success() {
                                afterSave();
                            }
                        });
                    });
                }
            }
        });
        return false;
    },
    deleteRole() {
        const view = this;
        ConfirmView.show({
            message: $._('role.message.delete'),
            title: $._('alert.action.delete'),
            yesFunc() {
                view.model.destroy({
                    success(formMessage) {
                        if (formMessage.showErrors()) {
                            AlertView.show({
                                message: $._('role.alert.delete.success'),
                                okFunc() {
                                    view.options.listView.render();
                                }
                            });
                        }
                    }
                });
            }
        });
    }
});
module.exports = DetailView;



// WEBPACK FOOTER //
// ./src/components/role/views/DetailView.js